import { render, staticRenderFns } from "./TheToolsDocument.vue?vue&type=template&id=25b67b3a&"
import script from "./TheToolsDocument.vue?vue&type=script&lang=js&"
export * from "./TheToolsDocument.vue?vue&type=script&lang=js&"
import style0 from "./TheToolsDocument.vue?vue&type=style&index=0&id=25b67b3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports